import { Link } from 'react-router'
import { CarouselRail } from '~/components-v2'
import { integrationsListCarousel } from '~/fragments/integrations/integrations'
import type { IntegrationItemProps } from '~/fragments/integrations/integrations'
import type { ReactNode } from 'react'

const isExternalLink = (href: string) => /^https?:\/\//.test(href)

const IntegrationRailItem = ({
  integration,
}: {
  integration: IntegrationItemProps
}) => {
  const { icon, link, name } = integration
  const content = (
    <>
      <span className="integration-rail-card__icon">{icon}</span>
      <span className="integration-rail-card__label body-m">{name}</span>
    </>
  )

  if (isExternalLink(link)) {
    return (
      <a
        className="integration-rail-card"
        href={link}
        rel="noreferrer"
        target="_blank"
      >
        {content}
      </a>
    )
  }

  return (
    <Link className="integration-rail-card" to={link}>
      {content}
    </Link>
  )
}

type IntegrationsCarouselProps = {
  header?: ReactNode
}

export const IntegrationsCarousel = ({ header }: IntegrationsCarouselProps) => {
  return (
    <CarouselRail
      className="integrations-rail"
      desktopEndSpacerSlides={4}
      desktopSlidesToScroll={3}
      desktopVisibleSlides={5}
      header={header}
      mobileSlidesToScroll={2}
      viewAll={{
        href: '/integrations',
        label: 'Learn more about Omni’s integrations',
      }}
      viewportControls
    >
      {integrationsListCarousel.map((integration) => (
        <IntegrationRailItem integration={integration} key={integration.name} />
      ))}
    </CarouselRail>
  )
}
